export const handleShowTabItemClick = (ref: React.MutableRefObject<any>) => {
  if (ref.current) {
    const elementPosition = ref.current.getBoundingClientRect().top + window.scrollY;
    const offset = 144;
    window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
  }
};
